import classNames from 'classnames';
import React, { FC } from 'react';

import { Typography } from '@/shared/components/atoms/Typography';

interface Props {
  className?: string;
  errorMessage: string;
}
const ErrorMessage: FC<Props> = ({ errorMessage, className }) => {
  const errorClasses = classNames('mt-8 text-error-default', className);

  return (
    <Typography className={errorClasses} variant='body2' weight='regular'>
      {errorMessage}
    </Typography>
  );
};

export default ErrorMessage;
